var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewmoilsvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 48,
    viewBox: "0 0 104 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_133_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 45,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2168 45.7198C29.3642 47.7711 31.601 48 33.4464 46.8368C40.0735 42.6636 44.7168 33.366 44.8746 25.4789C44.9966 19.3835 41.1242 15.7649 36.786 15.0304C32.0683 14.2268 26.7866 16.8328 25.8177 23.36C25.5067 25.4605 25.4576 30.1208 22.4975 30.2376C19.5389 30.1147 19.4898 25.4605 19.1787 23.36C18.2099 16.8328 12.9281 14.2268 8.21042 15.0304C3.87221 15.7634 -0.000172543 19.3819 0.118886 25.4774C0.276639 33.366 4.91993 42.6636 11.547 46.8353C13.3925 47.9985 15.6293 47.7695 16.7767 45.7182C17.2202 44.923 17.3592 43.9851 17.1664 43.0893C16.9736 42.1935 16.4629 41.4046 15.7349 40.8781C11.4563 38.6348 8.65987 34.2034 7.74311 28.6918C7.53476 27.4349 7.44547 27.0539 7.23563 25.6817C7.14937 25.0218 7.31748 24.3532 7.70379 23.8198C8.0901 23.2865 8.66374 22.9311 9.3013 22.8299C10.669 22.6333 12.0188 23.6074 12.2212 25.0287L12.6111 27.5041C12.7317 28.1356 12.879 28.7518 13.0576 29.3479C13.8196 31.7096 15.0623 33.9022 16.8035 35.4419C18.2813 36.6311 20.1505 37.3533 22.4662 37.4286C25.4323 37.3333 27.6661 36.1748 29.2823 34.3309C29.8963 33.5961 30.4294 32.7932 30.8718 31.937C31.5505 30.5362 32.0354 29.044 32.3124 27.5041L32.7023 25.0333C32.9047 23.612 34.256 22.6379 35.6222 22.8345C36.2584 22.9378 36.8301 23.2944 37.2146 23.8278C37.5991 24.3613 37.7658 25.029 37.679 25.6879C37.4721 27.06 37.3813 27.4411 37.1715 28.698C36.2785 34.102 33.567 38.4658 29.4327 40.7491L29.3419 40.8228C28.585 41.3382 28.0473 42.1327 27.8387 43.0437C27.6301 43.9547 27.7664 44.9136 28.2197 45.7244",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_133_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9968 14.2222H0V48H44.9968V14.2222Z",
    fill: "url(#paint0_linear_133_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_133_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 15,
    width: 42,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7427 29.0222V28.9991C69.7425 28.6452 69.7121 28.292 69.6519 27.9435C69.5015 26.9899 69.1695 26.0765 68.6749 25.2562C68.1803 24.436 67.5331 23.7251 66.7707 23.1649C65.6485 22.2122 64.2828 21.7359 62.6736 21.7359C60.979 21.7359 59.5488 22.2634 58.383 23.3185C57.4258 24.0748 56.6719 25.0712 56.1929 26.2131C55.7139 27.355 55.5258 28.6045 55.6464 29.8426C55.7671 31.0808 56.1925 32.2665 56.8821 33.287C57.5718 34.3075 58.5029 35.129 59.5868 35.6732C60.6707 36.2174 61.8714 36.4663 63.0748 36.3963C64.2782 36.3263 65.4442 35.9396 66.462 35.273C67.4798 34.6065 68.3155 33.6822 68.8897 32.5881C69.464 31.494 69.7576 30.2665 69.7427 29.0222ZM62.6736 42.6129C59.9848 42.6129 57.5719 42.0331 55.4348 40.8735C53.3612 39.7769 51.6249 38.105 50.4209 36.0457C49.2204 33.9878 48.6192 31.6517 48.6172 29.0375C48.6152 26.4234 49.2165 24.0878 50.4209 22.0309C51.6258 19.9739 53.362 18.3042 55.4348 17.2092C57.5719 16.0486 59.9848 15.4689 62.6736 15.4699C65.3623 15.4709 67.7673 16.0507 69.8885 17.2092C71.9498 18.3124 73.675 19.9835 74.8726 22.0371C76.0751 24.095 76.6764 26.4305 76.6764 29.0437C76.6764 31.6568 76.0751 33.9908 74.8726 36.0457C73.6747 38.0987 71.9496 39.7692 69.8885 40.872C67.7683 42.0315 65.3633 42.6118 62.6736 42.6129ZM85.3141 19.1315C85.8003 19.1313 86.2817 19.2299 86.7309 19.4219C87.1802 19.6139 87.5884 19.8953 87.9322 20.2502C88.2761 20.605 88.5488 21.0264 88.7349 21.4901C88.921 21.9538 89.0168 22.4509 89.0168 22.9528V38.3981C89.0168 39.412 88.6267 40.3844 87.9323 41.1014C87.2379 41.8183 86.2961 42.2211 85.3141 42.2211C84.3321 42.2211 83.3903 41.8183 82.6959 41.1014C82.0015 40.3844 81.6114 39.412 81.6114 38.3981V22.9528C81.6114 22.4509 81.7071 21.9538 81.8932 21.4901C82.0793 21.0264 82.3521 20.605 82.6959 20.2502C83.0398 19.8953 83.448 19.6139 83.8972 19.4219C84.3464 19.2299 84.8279 19.1313 85.3141 19.1315Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_133_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.0172 15.4637H48.625V42.6128H89.0172V15.4637Z",
    fill: "url(#paint1_linear_133_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_133_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 80,
    y: 6,
    width: 10,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3143 15.3239C84.0126 15.3239 82.9529 14.9219 82.1354 14.1177C81.7383 13.7365 81.4237 13.2729 81.2124 12.7573C81.001 12.2417 80.8977 11.6858 80.9091 11.1261C80.8974 10.5663 81.0006 10.0103 81.212 9.49468C81.4233 8.97904 81.738 8.51546 82.1354 8.13444C82.9529 7.33134 84.0126 6.92928 85.3143 6.92826C86.616 6.92723 87.6756 7.31341 88.4931 8.08681C88.889 8.44837 89.2037 8.89465 89.4155 9.39459C89.6273 9.89453 89.731 10.4361 89.7195 10.9817C89.7195 12.2355 89.3107 13.2726 88.4931 14.0931C87.6756 14.9137 86.616 15.3234 85.3143 15.3224",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_133_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7195 6.92825H80.9092V15.3239H89.7195V6.92825Z",
    fill: "url(#paint2_linear_133_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_133_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 95,
    y: 7,
    width: 9,
    height: 36
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6012 7.03583C100.583 7.03583 101.525 7.4386 102.219 8.15553C102.914 8.87247 103.304 9.84484 103.304 10.8587V38.3982C103.304 39.4121 102.914 40.3844 102.219 41.1014C101.525 41.8183 100.583 42.2211 99.6012 42.2211C98.6191 42.2211 97.6773 41.8183 96.9829 41.1014C96.2885 40.3844 95.8984 39.4121 95.8984 38.3982V10.8587C95.8984 9.84484 96.2885 8.87247 96.9829 8.15553C97.6773 7.4386 98.6191 7.03583 99.6012 7.03583Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_133_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.302 7.03583H95.8984V42.2195H103.302V7.03583Z",
    fill: "url(#paint3_linear_133_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_133_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 0,
    width: 11,
    height: 11
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3016 9.00029e-07C11.296 -0.000606975 10.3128 0.306714 9.47641 0.883093C8.63999 1.45947 7.98792 2.27901 7.60268 3.23806C7.21744 4.1971 7.11634 5.25256 7.31217 6.27093C7.50799 7.28931 7.99194 8.22485 8.70281 8.95921C9.41367 9.69358 10.3195 10.1938 11.3058 10.3966C12.292 10.5993 13.3143 10.4956 14.2435 10.0984C15.1726 9.70122 15.9667 9.02846 16.5255 8.16523C17.0842 7.302 17.3825 6.28707 17.3825 5.24882C17.3827 4.55974 17.2514 3.87736 16.9962 3.24066C16.7409 2.60395 16.3667 2.02538 15.8949 1.53798C15.4231 1.05058 14.863 0.663902 14.2464 0.400015C13.6299 0.136128 12.9691 0.000202652 12.3016 9.00029e-07Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_133_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3849 0H7.21875V10.4961H17.3849V0Z",
    fill: "url(#paint4_linear_133_2)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_133_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 0,
    width: 11,
    height: 11
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.702 2.25056e-07C31.6965 2.25056e-07 30.7136 0.307838 29.8776 0.884586C29.0415 1.46133 28.3899 2.28109 28.0051 3.24019C27.6204 4.19928 27.5197 5.25465 27.7159 6.27282C27.912 7.29099 28.3962 8.22624 29.1072 8.9603C29.8182 9.69436 30.724 10.1943 31.7102 10.3968C32.6963 10.5993 33.7185 10.4954 34.6475 10.0981C35.5764 9.70083 36.3704 9.02808 36.929 8.16491C37.4876 7.30175 37.7858 6.28694 37.7858 5.24882C37.786 4.55948 37.6546 3.87685 37.3992 3.23995C37.1438 2.60304 36.7693 2.02433 36.2972 1.53689C35.8251 1.04946 35.2646 0.662838 34.6477 0.399132C34.0308 0.135425 33.3696 -0.000201662 32.702 2.25056e-07Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_133_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7863 0H27.6201V10.4961H37.7863V0Z",
    fill: "url(#paint5_linear_133_2)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_2",
    x1: 21.947,
    y1: 37.0045,
    x2: 25.2305,
    y2: 4.09961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5843BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_133_2",
    x1: 67.6476,
    y1: 41.5649,
    x2: 70.9311,
    y2: 8.6615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5843BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_133_2",
    x1: 82.3275,
    y1: 43.0308,
    x2: 85.6109,
    y2: 10.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5843BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_133_2",
    x1: 97.7349,
    y1: 44.5674,
    x2: 101.018,
    y2: 11.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5843BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_133_2",
    x1: 10.0702,
    y1: 9.85691,
    x2: 14.5576,
    y2: 1.1657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5843BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6633"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_133_2",
    x1: 30.2781,
    y1: 9.77855,
    x2: 35.3681,
    y2: 0.856779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5843BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6633"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewmoilsvg);
export default __webpack_public_path__ + "static/media/newmoilsvg.1b00a102e8a498bfed4cc832f233d213.svg";
export { ForwardRef as ReactComponent };